import React, { Component } from "react";
import "animate.css/animate.min.css";
import ScrollAnimation from 'react-animate-on-scroll';

class Project extends Component {
  state = { display: false };

  componentDidMount() {
    this.setState({ display: true });
  }

  render() {
    return (
      <section id="Project" className="Project-tempalte-6 bg-light">
        <div class="container d-flex flex-column align-items-center py-4 py-xl-5">
          <div class="row">
            <div class="col-md-6 order-md-first mb-4">
              <ScrollAnimation animateIn="animate__fadeIn" animateOnce={true} delay={100}>
                <div class="card">
                  <img class="card-img w-100 d-block" src={require("../../assets/image/img-600x400-1.jpg")} />
                  <div class="card-img-overlay text-center d-flex flex-column justify-content-center align-items-center p-4">
                    <h4 class="font-weight-bold">Panel Solar</h4>
                    <p className="text-white">Descripción.</p>
                  </div>
                </div>
              </ScrollAnimation>

            </div>
            <div class="col-md-6 d-md-flex order-first justify-content-md-start align-items-md-center order-md-1 mb-4">
              <ScrollAnimation animateIn="animate__fadeIn" animateOnce={true} delay={150}>
                <h2 class="font-weight-bold">Nuestros proyectos</h2>
                <p class="w-lg-50">Descripción.</p>
              </ScrollAnimation>
            </div>
            <div class="col-md-6 order-md-2 mb-4">
              <ScrollAnimation animateIn="animate__fadeIn" animateOnce={true} delay={200}>
                <div class="card">
                  <img class="card-img w-100 d-block" src={require("../../assets/image/img-600x400-1.jpg")} />
                  <div class="card-img-overlay text-center d-flex flex-column justify-content-center align-items-center p-4">
                    <h4 class="font-weight-bold">Panel Solar</h4>
                    <p className="text-white">Descripción.</p>
                  </div>
                </div>
              </ScrollAnimation>
            </div>
            <div class="col-md-6 order-md-2 mb-4">
              <ScrollAnimation animateIn="animate__fadeIn" animateOnce={true} delay={250}>
                <div class="card">
                  <img class="card-img w-100 d-block" src={require("../../assets/image/img-600x400-1.jpg")} />
                  <div class="card-img-overlay text-center d-flex flex-column justify-content-center align-items-center p-4">
                    <h4 class="font-weight-bold">Panel Solar</h4>
                    <p className="text-white">Descripción.</p>
                  </div>
                </div>
              </ScrollAnimation>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Project;
